import { render, staticRenderFns } from "./DetailSideBar.vue?vue&type=template&id=70bbcc63&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./DetailSideBar.vue?vue&type=script&lang=ts&"
export * from "./DetailSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VRadio,VRadioGroup,VSelect,VTextarea})
